import React from "react";
import { Card, Tabs } from "antd";
import { useTranslation } from "react-i18next";

import { useSideTabsPosition } from "~/hooks/useIsMobile";
import TraineeBodyPhotos from "~/modules/Trainee/TraineeProfile/TraineeFeatures/TraineeBodyPhotos/TraineeBodyPhotos";
import TraineeBodyWeightMeasurements from "~/modules/Trainee/TraineeProfile/TraineeFeatures/TraineeMeasurements/TraineeBodyWeightMeasurements";
import { TraineeVideoRecordings } from "~/modules/Trainee/TraineeProfile/TraineeFeatures/TraineeMeasurements/TraineeVideoRecordings/TraineeVideoRecordings";
import { useTraineeId, useTraineeSearchParams } from "~/modules/Trainee/TraineeProfile/scope";

const TraineeMeasurements = () => {
  const sideTabsPosition = useSideTabsPosition();
  const { t } = useTranslation(["trainees", "common"]);
  const [searchParams] = useTraineeSearchParams();
  const defaultActiveTab = searchParams.get("subTab") || "bodyMeasurements";
  const traineeId = useTraineeId();

  return (
    <Card bordered={false}>
      <Tabs tabPosition={sideTabsPosition} defaultActiveKey={defaultActiveTab}>
        <Tabs.TabPane tab={t("measurements.title")} key="bodyMeasurements">
          <TraineeBodyWeightMeasurements traineeId={traineeId} />
        </Tabs.TabPane>
        <Tabs.TabPane tab={t("measurements.photos")} key="bodyPhotos">
          <TraineeBodyPhotos traineeId={traineeId} />
        </Tabs.TabPane>

        <Tabs.TabPane tab={t("measurements.videos")} key="videos">
          <TraineeVideoRecordings traineeId={traineeId} />
        </Tabs.TabPane>
      </Tabs>
    </Card>
  );
};

export default TraineeMeasurements;
